/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DeleteAiScanTargetResult = {
  /**
   * Version of the served list after the change.
   */
  listVersion: number;
};

/** @internal */
export const DeleteAiScanTargetResult$inboundSchema: z.ZodMiniType<
  DeleteAiScanTargetResult,
  unknown
> = z.pipe(
  z.object({
    list_version: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "list_version": "listVersion",
    });
  }),
);

export function deleteAiScanTargetResultFromJSON(
  jsonString: string,
): SafeParseResult<DeleteAiScanTargetResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeleteAiScanTargetResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeleteAiScanTargetResult' from JSON`,
  );
}
